import { useState, useEffect, useCallback, useMemo } from "react";
import { formatSelectOption } from "helpers/function";

export const useCountries = (countriesData = [], institutionCountry = null) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    if (countriesData && countriesData.length > 0) {
      const formattedCountries = formatSelectOption(
        countriesData,
        "name",
        null,
        "id"
      );
      setCountries(formattedCountries);
    }
  }, [countriesData]);

  useEffect(() => {
    if (institutionCountry) {
      setSelectedCountry({
        label: institutionCountry.name ?? "",
        value: institutionCountry.id ?? "",
      });
    }
  }, [institutionCountry]);

  const updateSelectedCountry = useCallback((countryOption) => {
    setSelectedCountry(countryOption);
  }, []);

  const countryOptions = useMemo(() => countries, [countries]);

  return {
    countries: countryOptions,
    selectedCountry,
    updateSelectedCountry,
  };
};
